var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlogImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.63636C6.27634 1.63636 1.63636 6.27633 1.63636 12C1.63636 17.7236 6.27634 22.3636 12 22.3636C17.7237 22.3636 22.3638 17.7236 22.3638 12C22.3638 6.27633 17.7237 1.63636 12 1.63636ZM0 12C0 5.37258 5.37259 0 12 0C18.6274 0 24.0001 5.37258 24.0001 12C24.0001 18.6274 18.6274 24 12 24C5.37259 24 0 18.6274 0 12Z",
    fill: "#E5B80B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.909 12.7272H1.09082V11.2726H22.909V12.7272Z",
    fill: "#E5B80B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2726 22.9091V1.09086H12.7271V22.9091H11.2726ZM17.2273 11.9999C17.2273 8.04949 15.8066 4.14137 13.0215 1.55733L13.8872 0.624329C16.9811 3.49482 18.5 7.76856 18.5 11.9999C18.5 16.2313 16.9811 20.5051 13.8872 23.3756L13.0215 22.4425C15.8066 19.8585 17.2273 15.9504 17.2273 11.9999ZM5.6358 12C5.6358 7.77471 7.10521 3.50319 10.1049 0.631201L10.9851 1.55051C8.28765 4.1331 6.90853 8.0434 6.90853 12C6.90855 15.9565 8.28768 19.8669 10.9851 22.4494L10.1049 23.3687C7.10524 20.4967 5.63582 16.2252 5.6358 12Z",
    fill: "#E5B80B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.56C15.9442 5.56 19.9551 6.28934 22.6739 7.80813C22.9808 7.97953 23.0906 8.3672 22.9192 8.67404C22.7479 8.98086 22.3601 9.09066 22.0533 8.91926C19.599 7.54826 15.8328 6.83273 12 6.83273C8.16716 6.83273 4.40097 7.54826 1.94664 8.91926C1.6398 9.09066 1.25213 8.98086 1.08073 8.67404C0.909344 8.3672 1.01913 7.97953 1.32596 7.80813C4.04486 6.28934 8.05572 5.56 12 5.56ZM12 18.0909C15.9442 18.0909 19.9551 17.3615 22.6739 15.8427C22.9808 15.6713 23.0906 15.2837 22.9192 14.9768C22.7479 14.67 22.3601 14.5602 22.0533 14.7316C19.599 16.1026 15.8328 16.8182 12 16.8182C8.16716 16.8182 4.40097 16.1026 1.94664 14.7316C1.6398 14.5602 1.25213 14.67 1.08073 14.9768C0.909344 15.2837 1.01913 15.6713 1.32596 15.8427C4.04486 17.3615 8.05572 18.0909 12 18.0909Z",
    fill: "#E5B80B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogImg1);
export default __webpack_public_path__ + "static/media/BlogImg1.7e3d6ffa45964b96a40bea68a16635c6.svg";
export { ForwardRef as ReactComponent };